import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import { space3XL, space4XL, spaceXXL } from '@xing-com/tokens';

const StyledGridContainer = styled(GridContainer)`
  margin-top: ${space3XL};

  @media ${mediaConfined} {
    margin-top: ${space4XL};
  }
`;

const StyledGridItem = styled(GridItem)`
  margin-bottom: ${spaceXXL};
`;

export const Styled = {
  GridContainer: StyledGridContainer,
  GridItem: StyledGridItem,
};
